import { getAssetPath } from '@/constants/configs';
import {
  defaultConfigs,
  getExtraBasicInfoQuestions as defaultGetExtraBasicInfoQuestions,
  resolveICBWebUrl,
} from '@/constants/tenant-configs/default';

import { AccountType, AccountTypeStatus } from '@/types/api/account';
import { QuestionCode } from '@/types/api/pep';
import {
  AppConfigurations,
  ExtraBasicInfoQuestions,
} from '@/types/app-configurations';
import { DocumentType } from '@/types/document';
import { Profession, User } from '@/types/user';

import {
  isBusinessPurposeQuestionEnabled,
  isExistingCustomer,
  isMinorUser,
} from '@/utils/user';

export const grenadaConfigs: AppConfigurations = {
  ...defaultConfigs,
  links: {
    ...defaultConfigs.links,
    privacyPolicyURL: 'https://republicgrenada.com/about/privacy-policy',
    termsAndConditionsURL:
      'https://www.republicgrenada.com/about/legal-notices',
    termsOfUseURL: getAssetPath('/tnc/republiconboard-tnc-grd.pdf'),
    appTermsAndConditionsURL: getAssetPath('/tnc/republiconboard-tnc-grd.pdf'),
    biometricConsentURL: getAssetPath(
      '/bio-consent/republiconboard-biometric-consent-grd.pdf',
    ),
    icbWeb: resolveICBWebUrl(
      'https://republiconlineec.rfhl.com/RBEC.UI/#/administrationGeneral/login',
    ),
    icbIOS: 'https://apps.apple.com/us/app/republicmobile-ec/id1582093121',
    icbAndroid:
      'https://play.google.com/store/apps/details?id=ecicprod.com.republicapp',
    eFreeURL: 'https://republicgrenada.com/personal/e-free',
    savingsPlusURL: 'https://republicgrenada.com/personal/savings-plus',
  },
  defaultCountryCode: '1473',
  locale: 'en-GD',
  isoCode: 'GRD',
  dateFormat: 'dd/MM/yyyy',
  defaultCurrency: 'XCD',
  scanIDAutoCaptureSeconds: 10,
  idCaptureRequirement: 'idCardOrPassport',
  showRiskSectorFlagQuestion: false,
  showSelfEmployedWithRiskSectorFlagQuestion: true,
  idDocumentTypes: [
    DocumentType.Passport,
    DocumentType.Nis,
    DocumentType.VoterID,
    DocumentType.IdentityDriverLicense,
  ],
  existingCustomer: {
    maxAccountsPerType: 2,
  },
  autoApproveUnemployedProfessions: [
    Profession.Pensioner,
    Profession.Housewife,
    Profession.Unemployed,
  ],
};

export const getExtraBasicInfoQuestions = (
  user: User,
): ExtraBasicInfoQuestions => {
  if (isMinorUser(user)) {
    return defaultGetExtraBasicInfoQuestions(user);
  }
  return {
    ...defaultGetExtraBasicInfoQuestions(user),
    [QuestionCode.AccountPurpose]: {
      enabled: isBusinessPurposeQuestionEnabled(user),
      question: 'questionDrawer.accountPurpose.question',
      priority: 0,
    },
    [QuestionCode.EXCPrimaryAccount]: {
      enabled:
        isExistingCustomer(user) &&
        !user.chargeAccountNo &&
        !!user.accountTypes?.find(
          type =>
            type.status === AccountTypeStatus.Active &&
            type.type === AccountType.Checking,
        ),
      question: 'questionDrawer.EXCPrimaryAccount.question',
      description: 'questionDrawer.EXCPrimaryAccount.description',
      priority: 5,
    },
  };
};
